import React from 'react'

import { Box, FormHelperText, FormLabel } from '@material-ui/core'

import { IOSSwitch } from '../IOSSwitch'

import { useSettingsPageStyles } from '../../hooks/settingsPageStylesHook'

export type StoreAccountMsShipmentSlotsToggleProps = {
  enabled: boolean

  onToggle: VoidFunction
}

export const StoreAccountMsShipmentSlotsToggle =
  ({enabled, onToggle}: StoreAccountMsShipmentSlotsToggleProps) => {
    const classes = useSettingsPageStyles()

    return (
      <Box width={'100%'} display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <FormLabel className={classes.unifiedPricesLabel}>
            Учёт ячеек при отгрузке в МойСклад
          </FormLabel>

          <FormHelperText className={classes.helperText}>
            Запрос остатков по ячейкам и формирование отгрузки с указанием ячеек.
            Включайте только при адресном хранении в МойСкладе.
          </FormHelperText>
        </Box>

        <IOSSwitch checked={enabled} onChange={onToggle}/>
      </Box>
    )
  }